import React from "react";
import CustomDataTable from "../../shared/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import DefaultAvatar from "../../../../assets/img/user-placeholder.svg";

const buildColumns = (group) => [
  {
    key: "employee_identifier",
    label: "Jogador",
    sortKey: "employee_identifier",
    render: (_v, item) => {
      const employee = group.employees.find(
        (e) => e.employee_identifier === item.employee_identifier,
      );
      const avatarUrl = employee && employee.avatar && employee.avatar.url
        ? employee.avatar.url
        : DefaultAvatar;
      return (
        <span className="analytics-player-row">
          <img alt="" src={avatarUrl} className="analytics-player-row__avatar" />
          <span className="analytics-player-row__name">{item.employee_identifier}</span>
        </span>
      );
    },
  },
  { key: "name", label: "Nome", sortKey: "name" },
  {
    key: "start_date",
    label: "Data de início",
    sortKey: "start_date",
    render: (_v, item) => formatDate(item.start_date),
  },
  {
    key: "end_date",
    label: "Data de fim",
    sortKey: "end_date",
    render: (_v, item) => formatDate(item.end_date),
  },
  {
    key: "percentage",
    label: "Atingimento",
    sortKey: "percentage",
    render: (_v, item) => `${parseFloat(item.percentage).toFixed(2)} %`,
  },
];

const sortFn = (data, sort) => {
  const sorted = [...data];
  sorted.sort((a, b) => {
    let valA, valB;
    if (sort.key === "start_date" || sort.key === "end_date") {
      valA = a[sort.key] ? new Date(a[sort.key]).getTime() : 0;
      valB = b[sort.key] ? new Date(b[sort.key]).getTime() : 0;
    } else if (sort.key === "percentage") {
      valA = Number(a.percentage) || 0;
      valB = Number(b.percentage) || 0;
    } else {
      valA = a[sort.key] || "";
      valB = b[sort.key] || "";
    }

    if (typeof valA === "string") {
      valA = valA.toLowerCase();
      valB = (valB || "").toLowerCase();
    }

    if (valA < valB) return sort.direction === "asc" ? -1 : 1;
    if (valA > valB) return sort.direction === "asc" ? 1 : -1;
    return 0;
  });
  return sorted;
};

const renderRow = (group, objective, index, className) => {
  const employee = group.employees.find(
    (e) => e.employee_identifier === objective.employee_identifier,
  );
  const name = objective.employee_identifier;
  const avatarUrl =
    employee.avatar && employee.avatar.url
      ? employee.avatar.url
      : DefaultAvatar;

  return (
    <tr
      key={
        objective.ojective_id
          ? `obj-${objective.ojective_id}-${objective.campaign_user_id}`
          : index
      }
      className={`data-table__row ${className}__row`}
    >
      <td
        className={`data-table__cell data-table__cell--employee_identifier ${className}__cell ${className}__cell--employee_identifier analytics-player-row`}
      >
        <img alt="" src={avatarUrl} className="analytics-player-row__avatar" />
        <span className="analytics-player-row__name">{name}</span>
      </td>
      <td
        className={`data-table__cell data-table__cell--name ${className}__cell ${className}__cell--name`}
      >
        {objective.name}
      </td>
      <td
        className={`data-table__cell data-table__cell--start_date ${className}__cell ${className}__cell--start_date`}
      >
        {formatDate(objective.start_date)}
      </td>
      <td
        className={`data-table__cell data-table__cell--end_date ${className}__cell ${className}__cell--end_date`}
      >
        {formatDate(objective.end_date)}
      </td>
      <td
        className={`data-table__cell data-table__cell--percentage ${className}__cell ${className}__cell--percentage`}
      >
        {parseFloat(objective.percentage).toFixed(2)} %
      </td>
    </tr>
  );
};

const ObjectivesTable = ({ objectives, pagination, group }) => (
  <CustomDataTable
    className="objectives-table"
    columns={buildColumns(group)}
    data={objectives}
    renderRow={(objective, index, className) =>
      renderRow(group, objective, index, className)
    }
    rowKey={(obj, index) =>
      obj.ojective_id ? `obj-${obj.ojective_id}-${obj.campaign_user_id}` : index
    }
    sortFn={sortFn}
    pagination={pagination}
    emptyMessage="Sem objetivos para apresentar."
  />
);

export default ObjectivesTable;
